module.exports = __webpack_public_path__ + "82dede47903d00bb7cbcf62a5b046d09.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/c21.png
// module id = 596
// module chunks = 0